import { BottomSheetDialog } from '@medely/web-components';
import React from 'react';
import { Box, VStack } from '@medely/ui-kit';
import { WorkGapForm } from '@mp/components/workGapForm/WorkGapForm';
import useDevice from '@mp/hooks/useDevice.web';
import { WorkGapModalProps } from './interface';

export const WorkGapModal = ({ open, onClose, workGap }: WorkGapModalProps) => {
  const isDesktop = useDevice() === 'desktop';
  const title = workGap ? 'Edit Work Gap' : 'Add Work Gap';

  return (
    <BottomSheetDialog
      maxWidth={false}
      open={open}
      onClose={onClose}
      title={title}
      data-testid="work-gap-modal"
      content={
        <Box width="90vw" maxWidth="600px">
          <VStack flex={1} pb={8}>
            <WorkGapForm onSuccess={() => onClose?.()} workGap={workGap} isModal />
          </VStack>
        </Box>
      }
      isDesktop={isDesktop}
    />
  );
};
